// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"c9f30ea1aa39410b","3484":"02797f766f741c1a","5510":"69987afe2f5fe7b5","6127":"ab82ac8df7410b67","6547":"7719b63cec4cbef7","7637":"1279fe7d0efe0ece","8430":"0f749e19e36820fa","8973":"66fb8d442a1af5a8"}[chunkId] + ".js";
};